import { render, staticRenderFns } from "./UserPayments.vue?vue&type=template&id=d927da80&scoped=true"
import script from "./UserPayments.vue?vue&type=script&lang=js"
export * from "./UserPayments.vue?vue&type=script&lang=js"
import style0 from "./UserPayments.vue?vue&type=style&index=0&id=d927da80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d927da80",
  null
  
)

export default component.exports